import { MenuItem, Menu as MuiMenu, PopoverOrigin, SxProps, Typography } from "@mui/material";
import React from "react";

type PropTypes = {
  anchorEl: any;
  handleClose: any;
  children?: React.ReactNode;
  anchorOrigin?: PopoverOrigin | undefined;
  sx?: SxProps;
  items?: {
    label: string | React.ReactNode;
    icon?: React.ReactNode;
    onClick: () => void;
    sx?: SxProps;
    sxText?: SxProps;
  }[];
};

const Menu: React.FC<PropTypes> = ({
  anchorEl,
  handleClose,
  children,
  anchorOrigin = { horizontal: "right", vertical: "top" },
  items,
  sx,
}) => {
  return (
    <MuiMenu
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      id="menu-appbar"
      keepMounted
      onClose={handleClose}
      open={Boolean(anchorEl)}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        "& .MuiPaper-root": {
          borderRadius: "8px",
          padding: "8px !important",
        },
        "& .MuiMenu-list": {
          padding: "0 !important",
          display: "flex",
          flexDirection: "column",
          gap: "2px",
        },
        ...sx,
      }}
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
    >
      {items?.map((item, index) => (
        <MenuItem
          key={index}
          onClick={item.onClick}
          sx={{
            height: "38px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: "12px",
            padding: "8px",
            // minWidth: "180px",
            ...item.sx,
          }}
        >
          {typeof item.label === "string" ? (
            <>
              {item.icon}
              {typeof item.label === "string" && (
                <Typography fontWeight={500} sx={{ fontSize: "16px", ...item.sxText }}>
                  {item.label}
                </Typography>
              )}
            </>
          ) : (
            item.label
          )}
        </MenuItem>
      ))}
      {children}
    </MuiMenu>
  );
};

export default Menu;
